import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './ErrorPage.module.css';

interface Props extends ComponentProps<'div'> {
  code: ReactNode;
  message: ReactNode;
  image: ReactNode;
  cta: ReactNode;
}

export default function ErrorPage({ className, code, message, image, cta, ...props }: Props) {
  return (
    <div
      className={clsx(styles.container, className)}
      {...props}
    >
      <h1 className={styles.code}>{code}</h1>
      <p className={styles.message}>{message}</p>
      <div className={styles.cta}>{cta}</div>
      <div className={styles.image}>{image}</div>
    </div>
  );
}
